import {DetailsBarController} from '../../componentsPage_widgets/details_bar/details_bar.controller';
import {VersionsDetailsController} from '../../componentsPage_widgets/latest_versions_widget/latest_versions.controller';
import {MainDetailsContainer} from '../../componentsPage_widgets/main_details_container/main_details_container.controller';

export class ComponentDetailsNewController {
    constructor($timeout, $state, $stateParams, ComponentsDao, XRayUtils, JFrogEventBus, JFrogNotifications) {
        this.homeData = {};
        this.JFrogNotifications = JFrogNotifications;
        this.$timeout = $timeout;
        this.componentsDao = ComponentsDao;
        this.jfrogEventBus = JFrogEventBus;

        this.EVENTS = JFrogEventBus.getEventsDefinition();
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.compId = this.$stateParams.componentID;
        this.xrayUtils = XRayUtils;
        this.widgetsOptions = {
            padding: 15,
            minHeight: 88,
            expandablePanes:true
        };
        this.sharedData = {};
        this.compDetails = {};
        this.defineWidgets();
        this.rootComponentId = this.currComponentId = $stateParams.componentID;
        this.rootComponentName = this.currComponentName = this.xrayUtils.getComponentPrettyName(this.rootComponentId);
        /*   this.$timeout(() => {
         this.getDetails();
         })*/

        this.getGeneralDetails();


    }


    defineWidgets() {
        this.widgets = {
            detailsBarWidget: {
                name: 'Details Bar',
                id: 'detailsBarWidget',
                template: require('../../componentsPage_widgets/details_bar/details_bar.html'),
                controller: DetailsBarController,
                scroll: false,
                blockExpand:true,
                model: {
                    sharedData: this.sharedData,
                    details: this.compDetails
                },
                showSpinner: true,
            },
            versionsWidget: {
                name: 'Versions',
                id: 'versionsWidget',
                template: require('../../componentsPage_widgets/latest_versions_widget/latest_versions.html'),
                controller: VersionsDetailsController,
                scroll: false,
                blockExpand:true,
                model: {
                    sharedData: this.sharedData,
                    details: this.compDetails
                },
                showSpinner: true,
            },
            MainDetailsWidget: {
                name: 'Main Details',
                id: 'MainDetailsWidget',
                template: require('../../componentsPage_widgets/main_details_container/main_details_container.html'),
                controller: MainDetailsContainer,
                scroll: false,
                model: {
                    sharedData: this.sharedData,
                    details: this.compDetails
                },
                showSpinner: true,
            }
        }
    }//define widget

    createLayout(type = 'normal') {

        if (type == 'normal') {
            this.widgetsLayout = {
                main: {
                    rows: [
                        {
                            size: '15%',
                            cells: ['100% #top']
                        },
                        {
                            size: '85%',
                            cells: ['100% #bottom']
                        }
                    ]
                },
                top: {
                    main: {
                        rows: [
                            {
                                size: '100%',
                                cells: ['100% @detailsBarWidget']
                            }
                        ]
                    }
                },
                bottom: {
                    main: {
                        rows: [
                            {
                                size: '100%',
                                cells: ['25% #bottomLeft', '75% #bottomRight']
                            }
                        ]
                    },
                    bottomLeft: {

                        main: {

                            rows: [{
                                size: '100%',
                                cells: ['100% #top']
                            }]
                        },
                        top: {
                            columns: [
                                {
                                    size: '100%',
                                    cells: ['100% @versionsWidget']
                                }
                            ]
                        }

                    },
                    bottomRight: {
                        columns: [
                            {
                                size: '100%',
                                cells: ['100% @MainDetailsWidget']
                            }
                        ]
                    }
                }
            };

        } else if (type == 'noVersionsPane') {

            this.widgetsLayout = {
                main: {
                    rows: [
                        {
                            size: '15%',
                            cells: ['100% #top']
                        },
                        {
                            size: '85%',
                            cells: ['100% #bottom']
                        }
                    ]
                },
                top: {
                    main: {
                        rows: [
                            {
                                size: '100%',
                                cells: ['100% @detailsBarWidget']
                            }
                        ]
                    }
                },
                bottom: {
                    main: {
                        rows: [
                            {
                                size: '100%',
                                cells: ['100% #bottomRight']
                            }
                        ]
                    },
                    bottomLeft: {

                        main: {

                            rows: [{
                                size: '100%',
                                cells: ['100% #top']
                            }]
                        },
                        top: {
                            columns: [
                                {
                                    size: '100%',
                                    cells: ['100% @versionsWidget']
                                }
                            ]
                        }

                    },
                    bottomRight: {
                        columns: [
                            {
                                size: '100%',
                                cells: ['100% @MainDetailsWidget']
                            }
                        ]
                    }
                }
            };

        }


    }// create layout function

    getDetails() {
        this.componentsDao.getDetails({$suppress_toaster: true}, {
            component_id: this.currComponentId
        }).$promise.then((details) => {

            if (details.status == 500) {
                this.JFrogNotifications.create(details.data);
                this.$state.go('components');
            }
            if (details.versions) {
                let sortedVersions = _.sortBy(details.data.versions, 'version_number');
            }
            this.sharedData.compDetails = details.data;
            if (details.data.general_details) {
                let compIdWithVersion = details.data.general_details.package_id;
            }

            this.$timeout(() => {
                this.jfrogEventBus.dispatch(this.EVENTS.COMPONENT_DATA_UPDATED, details.data);
            });

        });
    }

    getGeneralDetails() {

        this.componentsDao.getGeneral({$suppress_toaster: true}, {
            package_id: this.compId
        }).$promise.then((details) => {
            if (details) {
	            if ((details.type && details.type.toLowerCase() === 'file') || details.hide_versions_menu) {
                    this.createLayout('noVersionsPane');
                } else {
                    this.createLayout('normal');
                }
            }

            this.$timeout(() => {
                this.jfrogEventBus.dispatch(this.EVENTS.GENERAL_DETAILS_RECIEVED, details);
                this.jfrogEventBus.dispatch(this.EVENTS.COMPONENT_DATA_UPDATED, details);
            }, 500);


        });
    }

    hideVersionsPane() {

        let tmpObj = _.set(_.cloneDeep(this.widgetsLayout), 'bottom.main.rows[0].cells', ['100% #bottomRight']);
        this.widgetsLayout = tmpObj;

        this.sharedData.currentVersion = {};
        this.sharedData.currentVersion.type = 'file';

    }
}



// WEBPACK FOOTER //
// ./modules/xray/states/components_new/components_details_new.controller.js